/** @format */

import {If, IfElse, ModalFooter, ErrorBoundary, AdaptiveImage} from 'frontier-utilities';
import React, {useState, useEffect, useCallback} from 'react';
import {createPortal} from 'react-dom';

const ImageViewerPortal = props => {
    const {
        shouldUseAdaptiveImage = true,
        onClose = () => {},
        fullResPress = '',
        filename = '',
        width = '100%',
        height = 'auto',
        maxWidth = '1200px',
        fullRes = '',
        style,
        src = ''
    } = props;

    return createPortal(
        <ErrorBoundary>
            <div
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'fixed',
                    cursor: 'pointer',
                    display: 'flex',
                    zIndex: 3000,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    top: 0,
                    ...style
                }}
                onClick={onClose}>
                <IfElse condition={shouldUseAdaptiveImage}>
                    <AdaptiveImage
                        onClick={onClose}
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            maxHeight: '100%',
                            display: 'flex',
                            width: '100%',
                            zIndex: 2000,
                            maxWidth
                        }}
                        src={src}
                        title={filename}
                    />
                    <img
                        onClick={onClose}
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            zIndex: 2000,
                            maxWidth,
                            width,
                            height
                        }}
                        src={src}
                        alt={filename}
                    />
                </IfElse>
                {fullRes !== '' && (
                    <ModalFooter onClick={e => e.stopPropagation()}>
                        <div>
                            <a target="_blank" href={fullRes}>
                                Download Original Customer File
                            </a>
                        </div>
                        {fullResPress !== '' && (
                            <div>
                                <a
                                    className="btn btn-success btn-sm"
                                    target="_blank"
                                    href={fullResPress}>
                                    Download Press File
                                </a>
                            </div>
                        )}
                    </ModalFooter>
                )}
            </div>
        </ErrorBoundary>,
        portalRoot
    );
};

const portalRoot = document.getElementById('root');

const ImageViewer = props => {
    const {children, ...restOfProps} = props;

    const [isOpen, setIsOpen] = useState(false);

    const childrenWithClick = React.cloneElement(children, {
        onClick: () => setIsOpen(true)
    });

    const handleKeyCommands = useCallback(
        e => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        },
        [setIsOpen]
    );

    const listenToKeyboard = useCallback(
        enabled => {
            document.removeEventListener('keydown', handleKeyCommands);
            if (enabled) {
                document.addEventListener('keydown', handleKeyCommands);
            }
        },
        [handleKeyCommands]
    );

    useEffect(() => {
        listenToKeyboard(true);
        return () => {
            listenToKeyboard(false);
        };
    }, [listenToKeyboard]);

    return (
        <>
            <If condition={isOpen}>
                <ImageViewerPortal onClose={() => setIsOpen(false)} {...restOfProps} />
            </If>
            {childrenWithClick}
        </>
    );
};

export default ImageViewer;
